import type { RouteRecordRaw } from "vue-router";
import type { StandardFormRouteNames } from "@/views/electronicForm/electronicForm";

/**
 * Worksheet routes mounted under a parent form's `:id(\d+)` branch.
 *
 * - `/worksheets` → WorksheetChildList.vue (child list scoped to parent)
 *
 * The new-worksheet type picker is a top-level shared route; see
 * `electronicFormRouteNames.worksheetNew` in `electronicFormRoutes.tsx`.
 *
 * View/edit/new for a worksheet use that form's own routes under its form
 * code (e.g. `012_FlareWorksheet/:id/view`), not nested paths here.
 */
export function createWorksheetChildRoutes(formRouteNames: StandardFormRouteNames): RouteRecordRaw[] {
  return [
    {
      path: "worksheets",
      name: formRouteNames.worksheets,
      meta: { title: "Worksheets" },
      component: () => import("@/views/electronicForm/worksheets/WorksheetChildList.vue"),
      props: { formRouteNames },
    },
  ];
}
